import _ from 'lodash';
import { App } from '../features/home';
import { App as LayoutV2App } from '../features-v2/home';
import { PageNotFound } from '../features/common';
import { PageNotFound as PageNotFoundV2 } from '../features-v2/common';
import homeRoute from '../features/home/route';
import homeV2Route from '../features-v2/home/route';
import commonV2Route from '../features-v2/common/route';
import importV2Route from '../features-v2/import/route';
import templateV2Route from '../features-v2/template/route';
import pluginV2Route from '../features-v2/plugin/route';
import appSettingV2Route from '../features-v2/app-setting/route';
import dataConnectorV2Route from '../features-v2/data-connector/route';
import externalApiV2Route from '../features-v2/external-api/route';
import tutorialV2Route from '../features-v2/tutorial/route';
import collectionsV2Route from '../features-v2/collections/route';
import eventsV2Route from '../features-v2/events/route';
import projectOnBoardV2Route from '../features-v2/project-on-board/route';
import knowledgeBaseV2Route from '../features-v2/knowledge-base/route';
import loggerV2Route from '../features-v2/logger/route';
import onBoardingV2Route from '../features-v2/on-boarding/route';
import scheduleV2Route from '../features-v2/schedule/route';
import customComponentV2Route from '../features-v2/custom-component/route';
import permissionV2Route from '../features-v2/permission/route';
import deploymentSettingV2Route from '../features-v2/deployment-setting/route';
import aiPromptBuilderV2Route from '../features-v2/ai-prompt-builder/route';
import vibeCodingV2Route from '../features-v2/vibe-coding/route';
import commonRoute from '../features/common/route';
import importRoute from '../features/import/route';
import templateRoute from '../features/template/route';
import pluginRoute from '../features/plugin/route';
import appSettingRoute from '../features/app-setting/route';
import dataConnectorRoute from '../features/data-connector/route';
import externalApiRoute from '../features/external-api/route';
import tutorialRoute from '../features/tutorial/route';
import collectionsRoute from '../features/collections/route';
import eventsRoute from '../features/events/route';
import projectOnBoardRoute from '../features/project-on-board/route';
import knowledgeBaseRoute from '../features/knowledge-base/route';
import loggerRoute from '../features/logger/route';
import onBoardingRoute from '../features/on-boarding/route';
import scheduleRoute from '../features/schedule/route';
import customComponentRoute from '../features/custom-component/route';
import permissionRoute from '../features/permission/route';
import deploymentSettingRoute from '../features/deployment-setting/route';
import aiPromptBuilderRoute from '../features/ai-prompt-builder/route';

const childRoutes = [
  homeRoute,
  commonRoute,
  importRoute,
  templateRoute,
  pluginRoute,
  appSettingRoute,
  dataConnectorRoute,
  externalApiRoute,
  tutorialRoute,
  collectionsRoute,
  eventsRoute,
  projectOnBoardRoute,
  knowledgeBaseRoute,
  loggerRoute,
  onBoardingRoute,
  scheduleRoute,
  customComponentRoute,
  permissionRoute,
  deploymentSettingRoute,
  aiPromptBuilderRoute,
];

const layoutV2FeatureRoutes = [
  commonV2Route,
  importV2Route,
  templateV2Route,
  pluginV2Route,
  appSettingV2Route,
  dataConnectorV2Route,
  externalApiV2Route,
  tutorialV2Route,
  collectionsV2Route,
  eventsV2Route,
  projectOnBoardV2Route,
  knowledgeBaseV2Route,
  loggerV2Route,
  onBoardingV2Route,
  scheduleV2Route,
  customComponentV2Route,
  permissionV2Route,
  deploymentSettingV2Route,
  aiPromptBuilderV2Route,
  vibeCodingV2Route,
];

const routes = [
  {
    path: '/2.0',
    component: LayoutV2App,
    childRoutes: [
      homeV2Route,
      ...layoutV2FeatureRoutes,
      { path: '*', name: 'Page not found', component: PageNotFoundV2 },
    ].filter((r) => r.component || (r.childRoutes && r.childRoutes.length > 0)),
  },
  {
    path: '/',
    component: App,
    childRoutes: [
      ...childRoutes,
      { path: '*', name: 'Page not found', component: PageNotFound },
    ].filter((r) => r.component || (r.childRoutes && r.childRoutes.length > 0)),
  },
];

function handleIndexRoute(route) {
  if (!route.childRoutes || !route.childRoutes.length) {
    return;
  }

  const indexRoute = _.find(route.childRoutes, (child) => child.isIndex);
  if (indexRoute) {
    const first = { ...indexRoute };
    first.path = '';
    first.exact = true;
    first.autoIndexRoute = true;
    route.childRoutes.unshift(first);
  }
  route.childRoutes.forEach(handleIndexRoute);
}

routes.forEach(handleIndexRoute);
export default routes;
